module.exports = __webpack_public_path__ + "6071565cbaa5ab39e64f20cf2708c2e1.pdf";